// use-client-chakra-ui.ts
"use client";

export * from "@chakra-ui/react";
export * from "@chakra-ui/icons";
